export var SECTION_BEST_PICKS = 'bestpicks';
export var SECTION_BUYING_GUIDE = 'buying-guide';
export var SECTION_CONTAINER = 'container';
export var SECTION_MORECOVERAGE = 'morecoverage';
export var SECTION_OURAPPROACH = 'ourapproach';
export var SECTION_REVIEWS = 'reviews';
export var SECTION_SERVICES = 'services';
export var SECTION_WIDGET = 'widget';